import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import ModalDialog from '../../components/ModalDialog/ModalDialog';

const CloseDefectModal = ({
	open,
	onClose,
	onSubmit,
	submitting = false,
	selectedCount = 0,
}) => {
	const [reason, setReason] = useState('');
	const [remarks, setRemarks] = useState('');
	const [touched, setTouched] = useState(false);

	useEffect(() => {
		if (open) {
			setReason('');
			setRemarks('');
			setTouched(false);
		}
	}, [open]);

	const trimmedReason = useMemo(() => (reason || '').trim(), [reason]);
	const trimmedRemarks = useMemo(() => (remarks || '').trim(), [remarks]);

	const reasonError = touched && !trimmedReason;

	const btnSx = {
		minHeight: 56,
		minWidth: 160,
		px: 4,
		fontSize: '1.05rem',
		fontWeight: 700,
		textTransform: 'none',
		borderRadius: 2,
	};

	const handleCancel = () => {
		if (!submitting) onClose?.();
	};

	const handleSubmit = () => {
		setTouched(true);
		if (!trimmedReason) return;
		onSubmit?.({ reason: trimmedReason, remarks: trimmedRemarks });
	};

	return (
		<ModalDialog open={open} title="Close Defect(s)" onClose={handleCancel}>
			<Box sx={{ width: '100%', maxWidth: 520, mx: 'auto', px: { xs: 1, sm: 2 } }}>
				<Box sx={{ mb: 2 }}>
					<Typography variant="body2" sx={{ mb: 0.5 }}>
						<strong>{selectedCount}</strong> defect(s) will be closed.
					</Typography>
					<Typography variant="body2" sx={{ opacity: 0.8 }}>
						Reason and remarks will be applied to all selected defects.
					</Typography>
				</Box>

				<Grid container spacing={2.5}>
					<Grid item xs={12}>
						<TextField
							fullWidth
							label="Reason"
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							onBlur={() => setTouched(true)}
							required
							disabled={submitting}
							error={reasonError}
							helperText={reasonError ? 'Reason is required.' : ' '}
							inputProps={{ maxLength: 500 }}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							fullWidth
							label="Remarks"
							value={remarks}
							onChange={(e) => setRemarks(e.target.value)}
							placeholder="Optional"
							multiline
							rows={4}
							disabled={submitting}
							inputProps={{ maxLength: 1000 }}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>
				</Grid>

				<Box
					sx={{
						display: 'flex',
						justifyContent: 'flex-end',
						gap: 2,
						mt: 4,
						mb: 1,
						flexWrap: 'wrap',
					}}
				>
					<Button
						variant="outlined"
						size="large"
						onClick={handleCancel}
						disabled={submitting}
						sx={btnSx}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						size="large"
						disabled={submitting}
						onClick={handleSubmit}
						sx={{
							...btnSx,
							minWidth: 180,
							background: 'linear-gradient(90deg, #435C42 0%, #619C31 100%)',
							'&:hover': {
								background: 'linear-gradient(90deg, #385036 0%, #558A2B 100%)',
							},
						}}
					>
						{submitting ? 'Closing…' : 'Close Defect(s)'}
					</Button>
				</Box>
			</Box>
		</ModalDialog>
	);
};

export default CloseDefectModal;

